import { Grid } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { TextInput } from "components/FormControls/TextInput";
import { FieldArray, FieldArrayRenderProps } from "formik";
import { useMessage } from "hooks/intl";
import {
  DefaultLanguageDataState,
  selectDefaultLanguageData,
} from "reduxState/translations/translationsSlice";

interface Props {
  availableLanguages: DefaultLanguageDataState[];
  translations: { description?: string; locale?: string; name?: string }[];
  activeRule: number;
  errors: any;
}

export const RuleBasicSettings = ({
  availableLanguages,
  translations,
  activeRule,
  errors,
}: Props) => {
  const { message } = useMessage();
  const defaultLang = useAppSelector(selectDefaultLanguageData);

  return (
    <>
      {availableLanguages && (
        <FieldArray
          name={`rules[${activeRule}].translations`}
          render={(translationsArray: FieldArrayRenderProps) => {
            return (
              <>
                {translations?.map((item, index: number) => {
                  const isFirstRow = index === 0;

                  return (
                    <div key={index}>
                      <Grid
                        container
                        data-test-id={`rules-${index}-name`}
                        columnSpacing={12}
                        key={index}
                      >
                        <Grid xs={6} item>
                          <TextInput
                            data-test-id={`rules-${index}-name-${item?.locale}`}
                            label={message({
                              id: "ruleTitle",
                            })}
                            name={`rules[${activeRule}].translations[${index}].name`}
                            width="100%"
                            error={
                              errors?.translations &&
                              errors?.translations[defaultLang.code]?.name
                            }
                          />
                        </Grid>
                        <Grid xs={isFirstRow ? 6 : 5} item>
                          <TextInput
                            data-test-id={`rules-${index}-desc-${item?.locale}`}
                            label={message({
                              id: "ruleDescription",
                            })}
                            multiline
                            name={`rules[${activeRule}].translations[${index}].description`}
                            maxRows={7}
                            width="100%"
                          />
                        </Grid>
                      </Grid>
                    </div>
                  );
                })}
              </>
            );
          }}
        />
      )}
    </>
  );
};
